export const BASE_URL ='https://api.tamratdates.com';
// export const BASE_URL ='http://127.0.0.1:8000';
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const COUPONS_URL = '/api/coupons';
        